(function () {
    'use strict';

    angular
    .module('szallodak-detailmodal', []);
})();
